<template>
  <ListboxItem
    :value="user"
    class="group h-10 flex items-center shrink-0 py-px px-1.5 bg-primary data-[state=checked]:bg-brand-primary_alt data-[highlighted]:bg-primary_hover border border-secondary data-[state=checked]:border-brand rounded-sm data-[highlighted]:outline-none focus-visible:outline-none transition-colors cursor-pointer"
  >
    <div class="flex items-center px-2.5 gap-2">
      <Checkbox
        ref="checkboxRef"
        size="sm"
        :checked="checked"
        @update:checked="$emit('update:checked', $event)"
        :indeterminate="indetermiate"
        @click.stop
      />
      <Avatar
        :src="user.avatar_url"
        :initials="user.avatar_initials"
        size="sm"
        shape="square"
      />
      <div class="flex items-center grow">
        <span
          class="text-secondary group-data-[highlighted]:text-secondary_hover text-style-sm font-medium"
        >
          {{ user.fullname }}
        </span>
      </div>
    </div>
  </ListboxItem>
</template>

<script setup>
import { ref } from "vue";
import { ListboxItem } from "radix-vue";
import { Avatar } from "@/SharedComponents/Avatars";
import { Checkbox } from "@/SharedComponents/Checkboxes";

defineEmits(["update:checked"]);

const checkboxRef = ref(null);

const props = defineProps({
  user: { type: Object, required: true },
  checked: { type: [Boolean, String], default: true },
});

const indetermiate = props.checked === "indeterminate";

defineExpose({
  toggleChecked: () => checkboxRef.value?.$el.click(),
});
</script>
